import { locationsApi } from './index'

export default locationsApi.middleware
